import { useEffect, useState } from 'react'
import ACELogo from '../../asset/images/ACEApps.png'
import PropTypes from 'prop-types'
import FormLoader from '../FormLoader/FormLoader'
import { http } from '../../AxiosConfig'
import { REIMBURSEMENT_ID, USER_FORM_VALUES, USER_KEY } from '../../Cookies'
import toast, { Toaster } from 'react-hot-toast'

const hours = 8
const now = new Date().getTime()
const setupTime = localStorage.getItem('setupTime')
if (setupTime == null) {
  localStorage.setItem('setupTime', now)
}
else {
  if (now - setupTime > hours * 60 * 60 * 1000) {
    localStorage.clear()
    localStorage.setItem('setupTime', now)
  }
}

// TODO: get back term and POST
function UserLookupForm({ ...props }) {
  const getSessionStorage = localStorage.getItem(USER_FORM_VALUES)
    ? JSON.parse(localStorage.getItem(USER_FORM_VALUES))
    : {
        fullName: '',
        email: '',
        division: '',
      }

  // TODO: set state as a form object
  const [isDisabled, setIsDisabled] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [isDivisionLoading, setIsDivisionLoading] = useState(true)
  const [divisions, setDivisions] = useState([])
  const [formValues, setFormValues] = useState(getSessionStorage)

  const getFormsInput = () => {
    const params = { ...formValues }
    return { user: params }
  }

  useEffect(() => {
    const formKeys = Object.keys(formValues)
    const isFilledIn = formKeys?.every(key => formValues[key].length > 0)
    setIsDisabled(!isFilledIn || isLoading)
  }, [formValues])

  useEffect(() => {}, [])

  const fetchDivision = () => {
    setIsDivisionLoading(true)
    http
      .get('/db/divisions')
      .then(res => {
        const getDivisions = res?.data.data.map(d => d.attributes)
        setDivisions(getDivisions)
        setIsDivisionLoading(false)
      })
      .catch(err => {
        toast.error(
          `${err.message}`,
          {
            duration: 6000,
          },
        )
      })
      .finally(() => {})
  }

  const fetchUser = () => {
    localStorage.removeItem(REIMBURSEMENT_ID)
    localStorage.removeItem(USER_FORM_VALUES)
    setIsLoading(true)
    http
      .post(`/db/search`, getFormsInput())
      .then(res => {
        if (
          (res.status === 200)
          & (res.data.data.attributes.terms.length === 0)
        ) {
          toast.error(
            `No term found for ${res.data.data.attributes.name}, try different division`,
          )
        }
        else if (res.data.data.attributes.terms.length > 0) {
          localStorage.setItem(
            USER_KEY,
            JSON.stringify(res.data.data.attributes.id),
          )
          const lookUpUser = res?.data.data.attributes
          props.setUserData(lookUpUser)
        }
        // if (res.data.data.attributes.terms.length === 0) {
        //   toast.error('No valid term found for this division')
        // } else {
        //   localStorage.setItem(
        //     USER_KEY,
        //     JSON.stringify(res.data.data.attributes.id),
        //   )
        //   const lookUpUser = res?.data.data.attributes
        //   props.setUserData(lookUpUser)
        // }
      })
      .catch(err => {
        if (err.request.status == 404) {
          toast.error('No member found, check Name and Email')
        }
        else {
          toast.error(`${err.message}`)
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleSubmit = e => {
    e.preventDefault()
    localStorage.setItem(USER_FORM_VALUES, JSON.stringify(formValues))
    const formData = getFormsInput()
    fetchUser(formData)
  }

  const handleChange = e => {
    const name = e.target.name
    const value = e.target.value
    localStorage.setItem(USER_FORM_VALUES, JSON.stringify(formValues))
    setFormValues(values => ({ ...values, [name]: value }))
  }

  return (
    <div className="bg-zinc-800 shadow">
      <div className="container max-w-screen-lg mx-auto pb-10">
        <div className="flex justify-between">
          <img className="mx-auto" src={ACELogo} alt="ACE logo"></img>
        </div>
        <h1 className="text-3xl font-bold leading-7 text-center text-white">
          Reimbursement Request
        </h1>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div>
        <div className="max-w-5xl mx-auto px-6 sm:px-6 lg:px-8 mb-12">
          <div className="bg-zinc-900 w-full shadow rounded p-8 sm:p-12 grid grid-cols">
            <h1>
              <srong className="text-cyan-300">
                Welcome back! We have moved!
              </srong>
            </h1>
            <a className="underline" href={process.env.REACT_APP_BACKEND_LINK}>
              New App Link
            </a>
            <a
              id="continue-button-selector"
              className="setup-button"
              href={process.env.REACT_APP_BACKEND_SETUP_LINK}
            >
              Get started set up login
            </a>
          </div>
        </div>
      </div>
      <div className="h-1"></div>
    </div>
  )
}
UserLookupForm.propTypes = {
  setUserData: PropTypes.func,
}
export default UserLookupForm
